import React from "react";
import { useState } from "react";
import Highlighter from "react-highlight-words";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import nodeinstance from "../../../../nodeInstance";
import UploadFilePopUp from "../../../../ReusableComponents/UploadFile/uplaodFile";

export default function ListDependentMaster({ token, titles = [], list = [] }) {
  const [searchWords, setSearchWords] = React.useState([]);
  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(list?.data || []);
  const dispatch = useDispatch();

  const [downloadLoading, setDownloadLoading] = useState(false);
  const [Popup, setPopUp] = useState(false);

  const downloadFile = async () => {
    setDownloadLoading(true);
    try {
      const response = await nodeinstance.get(
        `/insurance-dependent/downloadDependentSummary`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `DependentSummary`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      setDownloadLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };

  const downloadTemplate = async () => {
    setDownloadLoading(true);
    try {
      const response = await nodeinstance.get(
        `/insurance-dependent/excelTemplate`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Insurance_Dependent_template`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (error) {
      setDownloadLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };

  return (
    <>
      <div className="pt-2 uppercase">
        <div className="flex space-x-2 ">
          <div className="gap-2 w-full items-center flex flex-row-reverse">
            <button
              className="bg-black text-white px-4 rounded-md py-2 text-sm h-[38px]"
              onClick={() => downloadTemplate()}
            >
              DOWNLOAD Template
            </button>
            <button
              className="bg-black text-white px-4 rounded-md py-2 text-sm h-[38px]"
              onClick={() => downloadFile()}
            >
              DOWNLOAD Report
            </button>

            <button
              className="bg-black text-white px-4 rounded-md py-2 text-sm h-[38px]"
              onClick={() => setPopUp(true)}
            >
              upload
            </button>

            <Search
              searchKey={[
                "emp_id",
                "dependent_iqama_number",
                "dependent_name",
                "iqama_number",
                "mobile_number",
                "emp_id",
                "sponsor_id",
              ]}
              setSearchWords={setSearchWords}
            />
          </div>
        </div>

        <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
        <CountPerPage />
        <div
          className={`grid grid-cols-table-workflow-dependentMaster auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
        >
          {titles.map((t, index) => (
            <p key={index} className="font-semibold uppercase">
              {t}
            </p>
          ))}
          {list?.isLoading && <LoadingWithLable className="col-span-6" />}
          {!list?.isLoading && <NoDataFound />}

          {!list?.isLoading
            ? currentList?.map((list, index) => (
                <React.Fragment key={index}>
                  <PaginationIndex index={index} />
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list?.dependent_name || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      // textToHighlight={list.dependent_dob || "-"}
                      textToHighlight={
                        list.dependent_dob
                          ? new Date(list.dependent_dob)
                              .toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })
                              .split(" ")
                              .join("-")
                              .toUpperCase()
                          : "-----"
                      }
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.dependent_iqama_number || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.dependent_relation || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.insurance_class || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.iqama_number || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      // textToHighlight={list.iqama_number || "-"}
                      textToHighlight={
                        list.apply_date
                          ? new Date(list.apply_date)
                              .toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })
                              .split(" ")
                              .join("-")
                              .toUpperCase()
                          : "-----"
                      }
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.policy_no || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={
                        list.insurance_issue_date
                          ? new Date(list.insurance_issue_date)
                              .toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })
                              .split(" ")
                              .join("-")
                              .toUpperCase()
                          : "-----"
                      }
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.insurance_co || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.membership_id || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.class || "-"}
                    />
                  </p>
                  {/* <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.insurance_status || "-"}
                  />
                </p> */}
                  <p>{list.status}</p>

                  <hr
                    className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                  />
                </React.Fragment>
              ))
            : ""}
        </div>
        <Pagination />
      </div>
      {Popup ? (
        <UploadFilePopUp
          PopUp={Popup}
          setPopUp={setPopUp}
          title={"Update insurance dependent"}
          url={"/insurance-dependent/uploadExcel"}
          callBack={""}
        />
      ) : (
        ""
      )}
    </>
  );
}
